import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Pages
import Home from './Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Cpanel from './pages/Cpanel';
import Domains from './pages/Domains';
import Ubuntu2204 from './pages/Ubuntu2204';
import Ubuntu2404 from './pages/Ubuntu2404';
import Ubuntu2410 from './pages/Ubuntu2410';
import Ubuntu2504 from './pages/Ubuntu2504';
import Debian11 from './pages/Debian11';
import Debian12 from './pages/Debian12';
import Almalinux8 from './pages/Almalinux8';
import Almalinux9 from './pages/Almalinux9';
import Almalinux10 from './pages/Almalinux10';
import Rockylinux8 from './pages/Rockylinux8';
import Rockylinux9 from './pages/Rockylinux9';
import Rockylinux10 from './pages/Rockylinux10';
import Centos9stream from './pages/Centos9stream';
import Centos10stream from './pages/Centos10stream';
import Wordpress from './pages/Wordpress';
import Webmin from './pages/Webmin';
import Prestashop from './pages/Prestashop'; // ✅ Renamed import
import Easypanel from './pages/Easypanel';
import Cyberpanel from './pages/Cyberpanel';
import Docker from './pages/Docker';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import DoNotSell from './pages/DoNotSell';
import Trust from './pages/Trust';
import Support from './pages/Support';
import Sitemap from './pages/Sitemap';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

import './styles/global.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cpanel" element={<Cpanel />} />
        <Route path="/domains" element={<Domains />} />
        <Route path="/wordpress" element={<Wordpress />} />
        <Route path="/webmin" element={<Webmin />} />
        <Route path="/prestashop" element={<Prestashop />} /> {/* ✅ Updated path */}
        <Route path="/easypanel" element={<Easypanel />} />
        <Route path="/cyberpanel" element={<Cyberpanel />} />
        <Route path="/docker" element={<Docker />} />
        <Route path="/ubuntu2204" element={<Ubuntu2204 />} />
        <Route path="/ubuntu2404" element={<Ubuntu2404 />} />
        <Route path="/ubuntu2410" element={<Ubuntu2410 />} />
        <Route path="/ubuntu2504" element={<Ubuntu2504 />} />
        <Route path="/debian11" element={<Debian11 />} />
        <Route path="/debian12" element={<Debian12 />} />
        <Route path="/almalinux8" element={<Almalinux8 />} />
        <Route path="/almalinux9" element={<Almalinux9 />} />
        <Route path="/almalinux10" element={<Almalinux10 />} />
        <Route path="/rockylinux8" element={<Rockylinux8 />} />
        <Route path="/rockylinux9" element={<Rockylinux9 />} />
        <Route path="/rockylinux10" element={<Rockylinux10 />} />
        <Route path="/centos9stream" element={<Centos9stream />} />
        <Route path="/centos10stream" element={<Centos10stream />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/donotsell" element={<DoNotSell />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/support" element={<Support />} />
        <Route path="/sitemap" element={<Sitemap />} />
      </Routes>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;
